export default __webpack_public_path__ + "static/media/Dhillon.38e3ba68.jpg";